import { render, staticRenderFns } from "./CommunityManualQuery.vue?vue&type=template&id=9d32f3e4&"
import script from "./CommunityManualQuery.vue?vue&type=script&lang=js&"
export * from "./CommunityManualQuery.vue?vue&type=script&lang=js&"
import style0 from "./CommunityManualQuery.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
